import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import { OrdersProvider } from "@/lib/OrdersContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import PendingPage from "@/pages/PendingPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import KanbanPage from "@/pages/KanbanPage";
import ClientesPage from "@/pages/ClientesPage";
import VehiculosPage from "@/pages/VehiculosPage";
import FacturacionPage from "@/pages/FacturacionPage";
import AjustesPage from "@/pages/AjustesPage";
import AdminPage from "@/pages/AdminPage";
import HistorialPage from "@/pages/HistorialPage";

const Gate = () => {
  const { session, loading, profileLoaded, active, profile, recovery } = useAuth();
  if (loading || (session && !profileLoaded)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#09090b]">
        <Loader2 className="h-6 w-6 animate-spin text-[var(--gold)]" />
      </div>
    );
  }
  if (!session) return <LoginPage />;
  if (recovery) return <ResetPasswordPage />;
  if (!active) return <PendingPage />;
  return (
    <OrdersProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<KanbanPage />} />
            <Route path="/clientes" element={<ClientesPage />} />
            <Route path="/vehiculos" element={<VehiculosPage />} />
            <Route path="/facturacion" element={<FacturacionPage />} />
            <Route path="/ajustes" element={<AjustesPage />} />
            <Route path="/historial" element={<HistorialPage />} />
            {profile?.es_admin === true && <Route path="/activaciones" element={<AdminPage />} />}
            <Route path="*" element={<KanbanPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </OrdersProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <Gate />
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
